<template>
  <!-- 修改字典对话框 -->
  <div class="body-box marginBox2">

    <el-row class="plan"></el-row>

    <!--表单区域-->
    <el-form
      ref="editFormRef"
      :model="editForm"
      :rules="rules"
      label-width="140px"
      style="padding: 20px; background-color: #fff;"
    >
      <el-row>
        <!--商品名字-->
        <el-col :span="8">
          <el-form-item label="商品名字" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入商品名字" />
          </el-form-item>
        </el-col>

        <!--数量-->
        <el-col :span="8">
          <el-form-item label="数量" prop="num">
            <el-input v-model="editForm.num" placeholder="请输入数量" />
          </el-form-item>
        </el-col>

        <!--分类字典-->
        <el-col :span="8">
          <el-form-item label="分类" prop="classifyId">
            <el-cascader
              style="width: 100%;"
              :options="classifyCheckList"
              :props="props"
              v-model="editForm.classifyId"
              clearable></el-cascader>
          </el-form-item>
        </el-col>

        <!--品牌字典-->
        <el-col :span="8">
          <el-form-item label="品牌" prop="brandId">
            <el-select style="width: 100%;" v-model="editForm.brandId" placeholder="请选择">
              <el-option
                v-for="item in brandCheckList"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--相关排序-->
        <el-col :span="8">
          <el-form-item label="相关排序" prop="absort">
            <el-input v-model="editForm.absort" placeholder="请输入相关排序" />
          </el-form-item>
        </el-col>

        <!--首页排序-->
        <el-col :span="8">
          <el-form-item label="首页排序" prop="resort">
            <el-input v-model="editForm.resort" placeholder="请输入首页排序" />
          </el-form-item>
        </el-col>
        <!--VIP商品-->
        <el-col :span="8">
          <el-form-item label="是否是VIP商品" prop="vipFlag">
            <el-switch
              v-model="editForm.vipFlag"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>

        <!--型号-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>型号</span>
          <span class="el-icon-circle-plus-outline" style="margin-left: 16px;cursor: pointer"
                @click="addFacility"></span>
        </el-col>

        <!--型号-->
        <el-col :span="24">
          <el-form label-width="140px">
            <div v-for="(item,index) in editForm.modeList" :key="index" class="shuttle_bus">
              <model-list :certifications='editForm.modeList' :index="index"></model-list>
            </div>
          </el-form>
        </el-col>

        <!--缩略图-->
        <el-col :span="24" class="label">
          <el-form-item label="缩略图">
            <thumbnail v-model="editForm.thumbnail" :md5s="editForm.thumbnail"></thumbnail>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="上传视频">
            <!--<qq-video v-model="editForm.video" :videoMd5="editForm.video"></qq-video>-->
            <qq-video-new v-model="editForm.video" :videoMd5="editForm.video"></qq-video-new>
          </el-form-item>
        </el-col>

        <!--轮播图-->
        <el-col :span="24" class="label">
          <el-form-item label="轮播图">
            <thumbnail-list v-model="editForm.carousel" :md5List="editForm.carousel"></thumbnail-list>
          </el-form-item>
        </el-col>

        <!--富文本-->
        <el-col :span="24" class="label">
          <el-form-item label="富文本">
            <editor ref="getAddEditor" v-model="editForm.brief" :type="'html'" :editorContent="editForm.brief"></editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="goBack">返 回</el-button>
      <el-button @click="modifyGoods">确 定</el-button>
    </div>
  </div>
</template>

<script>
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import Editor from '@/components/common/editor/editor'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import ModelList from '@/views/goods/modelList'
import { getDictsTree, selectDictByKey } from '@/api/user/dict/dict'
import { getData } from '@/utils/code'
import { addGoods, getGoodsById } from '@/api/goods/goods'
import QqVideoNew from '@/components/common/qqVideo/qqVideoNew'
import { goodsRules } from '@/js/rules'

export default {
  name: 'addGoods',
  components: { QqVideoNew, ModelList, ThumbnailList, Editor, Thumbnail },
  data() {
    return {
      title: '',
      editDialogVisible: false,
      editForm: {}, //添加组织表单
      props: {
        multiple: true,
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'name'
      },
      // 规则
      rules: goodsRules,
      //初始化的值
      classifyCheckList: [],
      //初始化的值
      brandCheckList: [],
      queryClassifyInfo: {
        current: 1,
        size: 20,
        key: 'CLASSIFY'
      },
      queryBrandInfo: {
        current: 1,
        size: 20,
        key: 'BRAND'
      },
      goodsId: ''
    }
  },
  created() {
    this.goodsId = this.$route.query.id
    this.initialize()
    this.getClassify()
    this.getBrand()
  },
  methods: {
    //初始化
    initialize() {
      getGoodsById(this.goodsId).then(res => {
        this.editForm = res.data
        this.editForm.classifyId = this.editForm.classifyId.split(',')
      })
    },

    //上传视频
    getVideo(md5) {
      this.editForm.video = md5.md5
    },

    //添加一行设施
    addFacility() {
      let obj = {
        amount: '',
        icon: '',
        integral: '',
        mode: '',
        score: ''
      }
      this.editForm.modeList.push(obj)
    },

    //返回
    goBack() {
      this.$router.go(-1)
    },

    //查询分类字典
    getClassify() {
      getDictsTree('CLASSIFY').then(res => {
        this.classifyCheckList = res.data
      })
    },

    //查询品牌字典
    getBrand() {
      this.getDictByKey(this.queryBrandInfo.key).then((result) => {
        this.brandCheckList = result
      })
    },

    //字典
    getDictByKey(query) {
      return new Promise((resolve, reject) => {
        selectDictByKey(query).then((response) => {
          let data = getData(response) ? getData(response) : []
          resolve(data)
        }).catch(() => {
          reject([])
        })
      })
    },

    modifyGoods() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        let flag = true
        this.editForm.modeList.forEach(f => {
          if (!f.amount || !f.icon || !f.integral || !f.mode || !f.score) {
            return flag = false
          }
        })
        if (flag && this.editForm.thumbnail && this.editForm.classifyId && this.editForm.brandId && this.editForm.brief) {
          delete this.editForm.classifyDict
          delete this.editForm.brandDict
          delete this.editForm.score
          delete this.editForm.amount
          delete this.editForm.originalPrice
          let val = this.editForm.classifyId
          this.editForm.classifyId = val.join(',')
          addGoods(this.editForm).then((response) => {
            let data = getData(response)
            if (data !== null) {
              this.$message.success('修改商品信息成功!')
              this.goBack()
            } else {
              this.$message.error('修改商品信息失败!')
            }
          })
        } else {
          this.$message.error('请完善信息')
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input {
  width: 90%;
}

/deep/ .shuttle_bus {
  position: relative;

  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}

/deep/ .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
